import React from 'react';
import styled from 'styled-components';
import { AccordionGroup, Accordion } from '@tvg/fuse-design';
import { renderContent } from 'utilities/content/content-utilities';
import { PriceTerm } from 'types/Product';
import BnplContent from './BnplContent';
import ViewAllStcOptions from './ViewAllStcOptions';
import SpreadCostFurtherContent from './SpreadCostFurtherContent';
import InterestFreeContent from './InterestFreeContent';
import { DialogText } from '../../styles/DialogStyles';

const StyledAccordionGroup = styled(AccordionGroup)`
  margin-bottom: var(--spacing-space16);
`;

const FooterText = styled(DialogText)`
  margin-bottom: var(--spacing-space16);
`;

type Props = {
  longestWeeklyPriceTermWithInterest?: PriceTerm;
  longestWeeklyPriceTermWithZeroInterest?: PriceTerm;
  priceTerms?: PriceTerm[];
  productName: string;
  showBNPL: boolean;
  skuPrice: string;
};

function YouCouldPayOptions({
  longestWeeklyPriceTermWithInterest,
  longestWeeklyPriceTermWithZeroInterest,
  priceTerms,
  productName,
  showBNPL,
  skuPrice,
}: Props) {
  const options = [
    {
      id: 'stc',
      name: renderContent('littlewoods.dialog.heading.stc'),
      content: longestWeeklyPriceTermWithInterest && (
        <SpreadCostFurtherContent
          productName={productName}
          skuPrice={skuPrice}
          longestWeeklyPriceTermWithInterest={longestWeeklyPriceTermWithInterest}
        />
      ),
    },
    {
      id: 'interestFree',
      name: renderContent('littlewoods.dialog.heading.interestFree'),
      content: longestWeeklyPriceTermWithZeroInterest && (
        <InterestFreeContent
          productName={productName}
          longestWeeklyPriceTermWithZeroInterest={longestWeeklyPriceTermWithZeroInterest}
        />
      ),
    },
    {
      id: 'viewAll',
      name: renderContent('littlewoods.dialog.heading.viewAll'),
      content: priceTerms?.length && <ViewAllStcOptions priceTerms={priceTerms} />,
    },
    {
      id: 'bnpl',
      name: renderContent('littlewoods.dialog.heading.bnpl'),
      content: showBNPL && <BnplContent showFooter={false} />,
    },
  ].filter((option) => option.content);

  return (
    <>
      {options.length && (
        <StyledAccordionGroup>
          {options.map((option) => (
            <Accordion key={option.id} heading={option.name} chevronInline={false} headingTag="h2" hideBorder>
              {option.content}
            </Accordion>
          ))}
        </StyledAccordionGroup>
      )}

      <FooterText tag="p" size="1" type="paragraph">
        {renderContent('littlewoods.dialog.data.footer')}
      </FooterText>
    </>
  );
}

export default YouCouldPayOptions;
